// src/pages/Lab/Lab.page.tsx

import LabComponent from '@components/pages/Lab/Lab.component'
import React from 'react'

function LabPage(): React.ReactElement {
  return <LabComponent />
}

export default LabPage
